export default __webpack_public_path__ + "static/media/svg-5.b6db0a39.svg";